import { useNavigate } from "@tanstack/react-router";
import { ChannelList } from "@/components/forwarding/ChannelList";
import { InlineError } from "@/components/forwarding/controls";
import { useEntitlements } from "@/lib/entitlements";
import { useChannelOverrides, useForwardingChannels } from "@/lib/hooks/useForwarding";
import { useTenant } from "@/lib/hooks/useTenant";

/** Passo 5: escolhe origem e destino na mesma lista de Grupos e canais. */
export function StepGrupos(): JSX.Element {
  const channels = useForwardingChannels();
  const overrides = useChannelOverrides();
  const { data } = useTenant();
  const entitlements = useEntitlements(data?.tenant);
  const navigate = useNavigate();

  if (channels.error) {
    return <InlineError message="Não foi possível carregar seus grupos. Tente de novo em instantes." />;
  }
  if (channels.isLoading) {
    return <div className="h-32 animate-pulse rounded-xl border border-border bg-card" aria-busy="true" />;
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Marque como <strong className="text-foreground">origem</strong> o grupo de onde vêm as ofertas e como{" "}
        <strong className="text-foreground">destino</strong> o grupo ou canal que recebe as mensagens convertidas.
        Os grupos aparecem aqui depois que a conta do passo Canal estiver conectada.
      </p>
      <ChannelList
        channels={channels.data ?? []}
        overrides={overrides.data ?? []}
        maxDestinations={entitlements.maxForwardingDestinations}
        onOpenOverride={() => void navigate({ to: "/app/grupos" })}
      />
    </div>
  );
}
